import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ChartColors } from '@src/assets/charts/charts.colors';
import { ConfigService } from '@src/services/layout/config.service';

@Component({ 
    selector: 'app-dashboard-bar-chart',
    templateUrl: './dashboard-bar-chart-component.html',
    styleUrls: ['./dashboard-bar-chart-component.scss']
 })

export class DashboardBarChartComponent implements OnChanges {
    @Input() chartData: { name: string, value: number }[];
    data: any;// { name: string, series: { name: string, value: number }[] }[];
    @Input() title = '';
    private _chartData: { name: string, value: number }[];
    color 
    options = {
        scheme: {
            domain: [ChartColors[0]]
        }
    };
    layoutOrientation: string;

    constructor(private configService: ConfigService) {
        this.layoutOrientation = this.configService.templateConf.layout.dir;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (!changes.chartData) {
            return;
        }

        if (changes.chartData.currentValue !== this._chartData) {
            this._chartData = changes.chartData.currentValue;
            // this.data = [{name: "", series: changes.chartData.currentValue }];
            this.data = this._chartData;
        }

    }
}
